(() => {
  const roots = document.querySelectorAll('[data-pbh-v2]');
  if (!roots.length) return;

  const getOffset = () => {
    const bar = document.querySelector('.section-quick-jump-bar.active');
    const stickyH = bar ? bar.getBoundingClientRect().height : 0;
    return stickyH + 12;
  };

  function getScrollStep(container) {
    const item = container.querySelector('.product-bundle-hero-v2__card--half');
    if (!item) return 0;
    const styles = window.getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.offsetWidth + gap;
  }

  function getActiveIndex(container) {
    const step = getScrollStep(container);
    if (step <= 0) return 0;
    return Math.round(container.scrollLeft / step);
  }

  function canScrollX(container) {
    return container.scrollWidth > container.clientWidth + 1;
  }

  function updateHalfProgress(container, group) {
    const progress = group.querySelector('[data-pbh-v2-half-progress]');
    const segments = group.querySelectorAll('.product-bundle-hero-v2__half-progress-segment');
    if (!segments.length) return;

    const needsNav = canScrollX(container);
    if (progress) {
      progress.hidden = !needsNav;
      progress.classList.toggle('is-complete', !needsNav);
    }
    if (!needsNav) return;

    const activeIndex = getActiveIndex(container);
    segments.forEach((segment, index) => {
      segment.classList.toggle('is-active', index === activeIndex);
    });
  }

  function initHalfCarousels(root) {
    root.querySelectorAll('[data-pbh-v2-half-scroll]').forEach((container) => {
      const group = container.closest('.product-bundle-hero-v2__half-group');
      if (!group) return;

      const segments = group.querySelectorAll('.product-bundle-hero-v2__half-progress-segment');
      if (!segments.length) return;

      const scrollToIndex = (index) => {
        const step = getScrollStep(container);
        if (step <= 0) return;
        const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
        const next = Math.min(Math.max(0, index * step), maxScroll);
        container.scrollTo({ left: next, behavior: 'smooth' });
      };

      const onScroll = () => updateHalfProgress(container, group);

      container.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      segments.forEach((segment) => {
        segment.addEventListener('click', () => {
          const index = Number(segment.dataset.slideIndex);
          if (Number.isNaN(index)) return;
          scrollToIndex(index);
        });
      });

      onScroll();
      requestAnimationFrame(onScroll);
    });
  }

  function refreshPaypal(container, priceCents) {
    if (!container) return;
    container.dataset.initialVariantPrice = String(priceCents || 0);
    container.innerHTML = '';
    if (!(window.paypal && typeof window.paypal.Messages === 'function')) return;
    const config = {
      amount: ((Number(priceCents) || 0) / 100).toFixed(2),
      currency: container.dataset.currency || 'USD',
      placement: 'product',
      style: { layout: 'text' },
    };
    if (container.dataset.buyerCountry) config.buyerCountry = container.dataset.buyerCountry;
    try {
      window.paypal.Messages(config).render('#' + container.id);
    } catch (e) {}
  }

  function cacheCardImageDefaults(card) {
    if (!card || card.dataset.pbhV2DefaultsCached === '1') return;
    const picture = card.querySelector('picture[data-pbh-v2-card-primary]');
    if (!picture) return;
    const img = picture.querySelector('img');
    const source = picture.querySelector('source[media*="989"]');
    if (img?.src) card.dataset.pbhV2DefaultPrimaryDesktop = img.src;
    if (source?.srcset) card.dataset.pbhV2DefaultPrimaryMobile = source.srcset;
    else if (img?.src) card.dataset.pbhV2DefaultPrimaryMobile = img.src;
    card.dataset.pbhV2DefaultsCached = '1';
  }

  function updateCardPrimaryImage(card, option) {
    const picture = card.querySelector('picture[data-pbh-v2-card-primary]');
    if (!picture) return;
    const img = picture.querySelector('img');
    const source = picture.querySelector('source[media*="989"]');
    const desktop =
      option?.dataset?.cardImage ||
      card.dataset.pbhV2DefaultPrimaryDesktop ||
      img?.src ||
      '';
    const mobile =
      option?.dataset?.cardImageMb ||
      option?.dataset?.cardImage ||
      card.dataset.pbhV2DefaultPrimaryMobile ||
      desktop;
    if (img && desktop) img.src = desktop;
    if (source && mobile) source.srcset = mobile;
  }

  function setMoneyText(el, value) {
    if (!el) return;
    const raw = String(value || '').trim();
    el.replaceChildren();
    if (!raw) return;

    const span = document.createElement('span');
    span.className = 'money';
    span.textContent = raw.replace(/<[^>]*>/g, '');
    el.appendChild(span);
  }

  function applyVariant(card, option) {
    if (!card || !option) return;

    const variantId = option.value;
    const price = option.dataset.price || '';
    const compare = option.dataset.compare || '';
    const save = option.dataset.save || '';
    const priceCents = option.dataset.priceCents || '0';
    const available = option.dataset.available !== 'false';

    card.dataset.variant = variantId;

    const priceCurrent = card.querySelector('[data-pbh-v2-price-current]');
    const priceCompare = card.querySelector('[data-pbh-v2-price-compare]');
    if (priceCurrent) setMoneyText(priceCurrent, price);
    if (priceCompare) {
      if (compare) {
        setMoneyText(priceCompare, compare);
        priceCompare.hidden = false;
      } else {
        priceCompare.replaceChildren();
        priceCompare.hidden = true;
      }
    }

    const badge = card.querySelector('[data-pbh-v2-badge]');
    const badgePrice = card.querySelector('[data-pbh-v2-badge-price]');
    if (badge) {
      if (save) {
        if (badgePrice) setMoneyText(badgePrice, save);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    const variantInput = card.querySelector('input.product-variant-id, input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = !available;
    }

    const submit = card.querySelector('.product-form__submit, button[name="add"]');
    if (submit) {
      submit.disabled = !available;
      if (!available) {
        submit.setAttribute('aria-disabled', 'true');
      } else {
        submit.removeAttribute('aria-disabled');
      }
    }

    refreshPaypal(card.querySelector('[data-paypal-messages-product]'), priceCents);
    updateCardPrimaryImage(card, option);
  }

  function initCardPrimaryImages(root) {
    root.querySelectorAll('.product-bundle-hero-v2__card').forEach((card) => {
      cacheCardImageDefaults(card);
      const select = card.querySelector('[data-pbh-v2-variant-select]');
      if (!select) return;
      const option = select.options[select.selectedIndex];
      if (option) updateCardPrimaryImage(card, option);
    });
  }

  function initVariantSelects(root) {
    root.querySelectorAll('[data-pbh-v2-variant-select]').forEach((select) => {
      if (select.dataset.pbhV2Bound === '1') return;
      select.dataset.pbhV2Bound = '1';

      const card = select.closest('.product-bundle-hero-v2__card');
      if (!card) return;

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        applyVariant(card, option);
      });
    });
  }

  roots.forEach((root) => {
    initHalfCarousels(root);
    initCardPrimaryImages(root);
    initVariantSelects(root);

    const pills = Array.from(root.querySelectorAll('[data-pbh-v2-pill]'));
    const scenes = Array.from(root.querySelectorAll('[data-pbh-v2-scene]'));
    if (!pills.length || !scenes.length) return;

    const setActivePill = (id) => {
      pills.forEach((pill) => {
        pill.classList.toggle('is-active', pill.getAttribute('data-target') === id);
      });
    };

    const scrollToScene = (id) => {
      const target = document.getElementById(id);
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - getOffset();
      window.scrollTo({ top, behavior: 'smooth' });
      setActivePill(id);
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const id = pill.getAttribute('data-target');
        if (!id) return;
        scrollToScene(id);
        if (window.innerWidth <= 989) {
          pill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const probe = window.scrollY + getOffset() + 80;
        let currentId = scenes[0].id;
        scenes.forEach((scene) => {
          const top = scene.getBoundingClientRect().top + window.scrollY;
          if (top <= probe) currentId = scene.id;
        });
        setActivePill(currentId);
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-pbh-v2]');
    if (!root) return;
    initHalfCarousels(root);
    initCardPrimaryImages(root);
    initVariantSelects(root);
  });
})();
